module.exports = __webpack_public_path__ + "img/female-teenager-foot.8e8cbf8e.svg";